// WHATEVER CAME BACK, AS A SENTENCE SOMEBODY CAN READ.
//
// A sibling of units.ts and there for the same reason: this app relays the
// control plane's own words rather than inventing its own, and every page that
// does so needs the same last-resort coercion. A rejection that is not an Error
// still has to be readable — the alternative on the page is "[object Object]",
// which tells a customer nothing and tells us nothing either.
//
// Lifted out of src/pages/KnowledgeBases.tsx by E14-t4, which needed the same
// three lines for the dashboard read. Two copies of this would eventually
// disagree about what an empty message renders as.
//
// It deliberately does NOT classify: "was this a guard refusal or a network
// failure" is a question the transport already answered by putting the guard
// name in the message (src/api/kbs.ts, src/api/dashboards.ts). Re-deciding it
// here would be a second opinion about a fact the server already stated.

/** The message an unknown rejection carries, or a sentence saying it carried none. */
export function messageOf(err: unknown): string {
  if (err instanceof Error && err.message !== '') return err.message;
  const said = String(err);
  return said === '' ? 'the request failed without saying why' : said;
}
